import { render, staticRenderFns } from "./VendorNotesReport.vue?vue&type=template&id=652d310f"
import script from "./VendorNotesReport.vue?vue&type=script&lang=ts"
export * from "./VendorNotesReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports